import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { InlineClassDescriptor2odlvyasjrmr0 as InlineClassDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/InlineClassDescriptor.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  References31yy1vpluik8j as References,
  IndexUniqueness_Unique_getInstance3k1wv494ui8l1 as IndexUniqueness_Unique_getInstance,
  IndexSetppgakdbfpe00 as IndexSet,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import {
  UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance,
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import {
  Companion_getInstanceapne0fh8g5sn as Companion_getInstance,
  $serializer_getInstancegx2p6odi22tj as $serializer_getInstance,
} from './types.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  compareTo1g8l26b65emtd as compareTo,
  TypedIdexo9ecsepo30 as TypedId,
  HasId24qpfucecockd as HasId,
} from '../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { DatePeriodSerializer_getInstance41w3hzzadrlu as DatePeriodSerializer_getInstance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/DateTimePeriodSerializers.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/ObjectSerializer.mjs';
import { SealedClassSerializeriwipiibk55zc as SealedClassSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SealedSerializer.mjs';
import {
  $serializer_getInstance2m8ynx42p4oox as $serializer_getInstance_0,
  $serializer_getInstance2jfn7wtddihen as $serializer_getInstance_1,
  Companion_getInstance1wc081wkfo40w as Companion_getInstance_1,
  Companion_getInstance2kycdbli06tg as Companion_getInstance_2,
  IDqqik72jjbpsn as ID,
  ID__hashCode_impl_f4lulzrhf9x0v3ec95 as ID__hashCode_impl_f4lulz,
} from './domain.mjs';
import {
  emptySetcxexqki71qfa as emptySet,
  setOfNotNull1ug1800sfjuu0 as setOfNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  now2qufyxzn5e863 as now,
  get_TCG_TIME_ZONEb89pisv39t5w as get_TCG_TIME_ZONE,
} from './clock.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { toLocalDateTime2fafgh396r2y5 as toLocalDateTime } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { plus1oi9f9vif99u2 as plus } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { plus1ogy4liedzq5j as plus_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function Survey$Audience$Companion$_anonymous__atf93z() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.Survey.Audience', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Audience_AnonymousEmployee_instance = new (Audience())('AnonymousEmployee', 0);
  Audience_Families_instance = new (Audience())('Families', 1);
  Audience_Employers_instance = new (Audience())('Employers', 2);
  Audience_Providers_instance = new (Audience())('Providers', 3);
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var Audience_AnonymousEmployee_instance;
var Audience_Families_instance;
var Audience_Employers_instance;
var Audience_Providers_instance;
function values() {
  static_init();
  return [Audience_AnonymousEmployee_getInstance(), Audience_Families_getInstance(), Audience_Employers_getInstance(), Audience_Providers_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, Survey$Audience$Companion$_anonymous__atf93z);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_3() {
  static_init();
  return Companion_instance_0;
}
var $ENTRIES;
function _ID___init__impl__k1lb7e(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5($this) {
  return $this;
}
function ID__toString_impl_y5caka($this) {
  return _ID___get_raw__impl__92g6u5($this).toString();
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  return Companion_instance_1;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.Survey.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(Survey())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ei05b6_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ei05b6_k$(encoder, value instanceof ID_0() ? value.raw_1 : THROW_CCE());
      }
      deserialize_bstxgt_k$(decoder) {
        return _ID___init__impl__k1lb7e(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_0())(this.deserialize_bstxgt_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_2() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
function ID__hashCode_impl_f4lulz_0($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p($this, other) {
  if (!(other instanceof ID_0()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_0())(other instanceof ID_0() ? other.raw_1 : THROW_CCE()));
}
function Survey$Companion$$childSerializers$_anonymous__mszl80() {
  return new (ArrayListSerializer())($serializer_getInstance_10());
}
function Survey$Companion$$childSerializers$_anonymous__mszl80_0() {
  return Companion_getInstance_3().serializer_9w0wvi_k$();
}
function Survey$Companion$$childSerializers$_anonymous__mszl80_1() {
  return new (LinkedHashMapSerializer())(Companion_getInstance().serializer_9w0wvi_k$(), new (LinkedHashMapSerializer())(StringSerializer_getInstance(), StringSerializer_getInstance()));
}
var AudienceClass;
function Audience() {
  if (AudienceClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Audience', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
    AudienceClass = $;
  }
  return AudienceClass;
}
var IDClass;
function ID_0() {
  if (IDClass === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_0(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_2});
    IDClass = $;
  }
  return IDClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, Survey$Companion$$childSerializers$_anonymous__mszl80);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, Survey$Companion$$childSerializers$_anonymous__mszl80_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, tmp_1, tmp_3, lazy(tmp_4, Survey$Companion$$childSerializers$_anonymous__mszl80_1)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 === VOID)
    new (Companion_1())();
  return Companion_instance_2;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Survey', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('available', true);
        tmp0_serialDesc.addElement_5pzumi_k$('maximumFrequency', true);
        tmp0_serialDesc.addElement_5pzumi_k$('questions', false);
        tmp0_serialDesc.addElement_5pzumi_k$('audience', true);
        tmp0_serialDesc.addElement_5pzumi_k$('translations', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_c59jgj_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_5().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_2(), new (ID_0())(value._id_1));
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.name_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.available_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, $serializer_getInstance(), value.available_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.maximumFrequency_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, DatePeriodSerializer_getInstance(), value.maximumFrequency_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.questions_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !value.audience_1.equals(Audience_AnonymousEmployee_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, tmp2_cached[5].get_value_j01efc_k$(), value.audience_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.mapOf' call
          var tmp$ret$0 = emptyMap();
          tmp = !equals(value.translations_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, tmp2_cached[6].get_value_j01efc_k$(), value.translations_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_c59jgj_k$(encoder, value instanceof Survey() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_5().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_2();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_0())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, DatePeriodSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp12_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp12_cached[5].get_value_j01efc_k$(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp12_cached[6].get_value_j01efc_k$(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_2();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_0())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, DatePeriodSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp12_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp12_cached[5].get_value_j01efc_k$(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp12_cached[6].get_value_j01efc_k$(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Survey().new_org_thecommunitygroupinc_cares_Survey_xe9m29_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_5().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_2(), StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(DatePeriodSerializer_getInstance()), tmp0_cached[4].get_value_j01efc_k$(), tmp0_cached[5].get_value_j01efc_k$(), tmp0_cached[6].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_3() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
function Audience_AnonymousEmployee_getInstance() {
  static_init();
  return Audience_AnonymousEmployee_instance;
}
function Audience_Families_getInstance() {
  static_init();
  return Audience_Families_instance;
}
function Audience_Employers_getInstance() {
  static_init();
  return Audience_Employers_instance;
}
function Audience_Providers_getInstance() {
  static_init();
  return Audience_Providers_instance;
}
var SurveyClass;
function Survey() {
  if (SurveyClass === VOID) {
    class $ {
      constructor(_id, name, available, maximumFrequency, questions, audience, translations) {
        Companion_getInstance_5();
        _id = _id === VOID ? _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        available = available === VOID ? null : available;
        maximumFrequency = maximumFrequency === VOID ? null : maximumFrequency;
        audience = audience === VOID ? Audience_AnonymousEmployee_getInstance() : audience;
        var tmp;
        if (translations === VOID) {
          // Inline function 'kotlin.collections.mapOf' call
          tmp = emptyMap();
        } else {
          tmp = translations;
        }
        translations = tmp;
        this._id_1 = _id;
        this.name_1 = name;
        this.available_1 = available;
        this.maximumFrequency_1 = maximumFrequency;
        this.questions_1 = questions;
        this.audience_1 = audience;
        this.translations_1 = translations;
      }
      get__id_y8qg6e_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_0())(this.get__id_y8qg6e_k$());
      }
      toString() {
        return 'Survey(_id=' + ID__toString_impl_y5caka(this._id_1) + ', name=' + this.name_1 + ', available=' + toString_0(this.available_1) + ', maximumFrequency=' + toString_0(this.maximumFrequency_1) + ', questions=' + toString(this.questions_1) + ', audience=' + this.audience_1.toString() + ', translations=' + toString(this.translations_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_0(this._id_1);
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + (this.available_1 == null ? 0 : this.available_1.hashCode()) | 0;
        result = imul(result, 31) + (this.maximumFrequency_1 == null ? 0 : this.maximumFrequency_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.questions_1) | 0;
        result = imul(result, 31) + this.audience_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.translations_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Survey()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!equals(this.available_1, other.available_1))
          return false;
        if (!equals(this.maximumFrequency_1, other.maximumFrequency_1))
          return false;
        if (!equals(this.questions_1, other.questions_1))
          return false;
        if (!this.audience_1.equals(other.audience_1))
          return false;
        if (!equals(this.translations_1, other.translations_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Survey_xe9m29_k$(seen0, _id, name, available, maximumFrequency, questions, audience, translations, serializationConstructorMarker) {
        Companion_getInstance_5();
        if (!(18 === (18 & seen0))) {
          throwMissingFieldException(seen0, 18, $serializer_getInstance_3().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.name_1 = name;
        if (0 === (seen0 & 4))
          $this.available_1 = null;
        else
          $this.available_1 = available;
        if (0 === (seen0 & 8))
          $this.maximumFrequency_1 = null;
        else
          $this.maximumFrequency_1 = maximumFrequency;
        $this.questions_1 = questions;
        if (0 === (seen0 & 32))
          $this.audience_1 = Audience_AnonymousEmployee_getInstance();
        else
          $this.audience_1 = audience;
        if (0 === (seen0 & 64)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.mapOf' call
          tmp.translations_1 = emptyMap();
        } else
          $this.translations_1 = translations;
        return $this;
      }
    }
    initMetadataForClass($, 'Survey', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_3});
    SurveyClass = $;
  }
  return SurveyClass;
}
function _ID___init__impl__k1lb7e_0(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_0($this) {
  return $this;
}
function ID__toString_impl_y5caka_0($this) {
  return _ID___get_raw__impl__92g6u5_0($this).toString();
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_6() {
  return Companion_instance_3;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.Question.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_g5knmy_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_0(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_g5knmy_k$(encoder, value instanceof ID_1() ? value.raw_1 : THROW_CCE());
      }
      deserialize_v82sef_k$(decoder) {
        return _ID___init__impl__k1lb7e_0(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_1())(this.deserialize_v82sef_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_4() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function ID__hashCode_impl_f4lulz_1($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_0($this, other) {
  if (!(other instanceof ID_1()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_0($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_1())(other instanceof ID_1() ? other.raw_1 : THROW_CCE()));
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function Question$Type$FreeText$_anonymous__7o0hbm() {
  var tmp = FreeText_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer().new_kotlinx_serialization_internal_ObjectSerializer_ezfnxd_k$('org.thecommunitygroupinc.cares.Question.Type.FreeText', tmp, tmp$ret$0);
}
function Question$Type$SingleChoice$Companion$$childSerializers$_anonymous__nzev5h() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [lazy(tmp_0, Question$Type$SingleChoice$Companion$$childSerializers$_anonymous__nzev5h)];
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_7() {
  if (Companion_instance_4 === VOID)
    new (Companion_3())();
  return Companion_instance_4;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Question.Type.SingleChoice', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('options', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_gxjg9t_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_7().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.options_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_gxjg9t_k$(encoder, value instanceof SingleChoice() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp6_cached = Companion_getInstance_7().$childSerializers_1;
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp6_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp6_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SingleChoice().new_org_thecommunitygroupinc_cares_Question_Type_SingleChoice_v762u8_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_7().$childSerializers_1[0].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_5() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
function Question$Type$MultipleChoice$Companion$$childSerializers$_anonymous__8mz0j1() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [lazy(tmp_0, Question$Type$MultipleChoice$Companion$$childSerializers$_anonymous__8mz0j1)];
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_8() {
  if (Companion_instance_5 === VOID)
    new (Companion_4())();
  return Companion_instance_5;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Question.Type.MultipleChoice', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('options', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_rvx0ix_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_8().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.options_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_rvx0ix_k$(encoder, value instanceof MultipleChoice() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp6_cached = Companion_getInstance_8().$childSerializers_1;
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp6_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp6_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return MultipleChoice().new_org_thecommunitygroupinc_cares_Question_Type_MultipleChoice_1ke5t4_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_8().$childSerializers_1[0].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_6() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_9() {
  return Companion_instance_6;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Question.Type.Scale', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('lowerName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('lowerInt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('upperName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('upperInt', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_6gvvja_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.lowerName_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.lowerInt_1 === 1)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 1, value.lowerInt_1);
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.upperName_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.upperInt_1 === 5)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 3, value.upperInt_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_6gvvja_k$(encoder, value instanceof Scale() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0;
        var tmp6_local2 = null;
        var tmp7_local3 = 0;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeIntElement_941u6a_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Scale().new_org_thecommunitygroupinc_cares_Question_Type_Scale_uod5l6_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_7() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_7;
function Companion_getInstance_10() {
  return Companion_instance_7;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Question.Type.FreeNumber', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('prefix', true);
        tmp0_serialDesc.addElement_5pzumi_k$('postfix', true);
        tmp0_serialDesc.addElement_5pzumi_k$('integersOnly', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_dzodbh_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.prefix_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.prefix_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.postfix_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.postfix_1);
        }
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 2, value.integersOnly_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_dzodbh_k$(encoder, value instanceof FreeNumber() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FreeNumber().new_org_thecommunitygroupinc_cares_Question_Type_FreeNumber_pg0hv0_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_8() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
var FreeTextClass;
function FreeText() {
  if (FreeTextClass === VOID) {
    class $ {
      constructor() {
        FreeText_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, Question$Type$FreeText$_anonymous__7o0hbm);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForObject($, 'FreeText', VOID, VOID, [Type(), SerializerFactory()], VOID, VOID, {0: FreeText_getInstance});
    FreeTextClass = $;
  }
  return FreeTextClass;
}
var FreeText_instance;
function FreeText_getInstance() {
  if (FreeText_instance === VOID)
    new (FreeText())();
  return FreeText_instance;
}
var SingleChoiceClass;
function SingleChoice() {
  if (SingleChoiceClass === VOID) {
    class $ {
      constructor(options) {
        Companion_getInstance_7();
        this.options_1 = options;
      }
      toString() {
        return 'SingleChoice(options=' + toString(this.options_1) + ')';
      }
      hashCode() {
        return hashCode(this.options_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SingleChoice()))
          return false;
        if (!equals(this.options_1, other.options_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Question_Type_SingleChoice_v762u8_k$(seen0, options, serializationConstructorMarker) {
        Companion_getInstance_7();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_5().descriptor_1);
        }
        var $this = createThis(this);
        $this.options_1 = options;
        return $this;
      }
    }
    initMetadataForClass($, 'SingleChoice', VOID, VOID, [Type()], VOID, VOID, {0: $serializer_getInstance_5});
    SingleChoiceClass = $;
  }
  return SingleChoiceClass;
}
var MultipleChoiceClass;
function MultipleChoice() {
  if (MultipleChoiceClass === VOID) {
    class $ {
      constructor(options) {
        Companion_getInstance_8();
        this.options_1 = options;
      }
      toString() {
        return 'MultipleChoice(options=' + toString(this.options_1) + ')';
      }
      hashCode() {
        return hashCode(this.options_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MultipleChoice()))
          return false;
        if (!equals(this.options_1, other.options_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Question_Type_MultipleChoice_1ke5t4_k$(seen0, options, serializationConstructorMarker) {
        Companion_getInstance_8();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_6().descriptor_1);
        }
        var $this = createThis(this);
        $this.options_1 = options;
        return $this;
      }
    }
    initMetadataForClass($, 'MultipleChoice', VOID, VOID, [Type()], VOID, VOID, {0: $serializer_getInstance_6});
    MultipleChoiceClass = $;
  }
  return MultipleChoiceClass;
}
var ScaleClass;
function Scale() {
  if (ScaleClass === VOID) {
    class $ {
      constructor(lowerName, lowerInt, upperName, upperInt) {
        lowerInt = lowerInt === VOID ? 1 : lowerInt;
        upperInt = upperInt === VOID ? 5 : upperInt;
        this.lowerName_1 = lowerName;
        this.lowerInt_1 = lowerInt;
        this.upperName_1 = upperName;
        this.upperInt_1 = upperInt;
      }
      toString() {
        return 'Scale(lowerName=' + this.lowerName_1 + ', lowerInt=' + this.lowerInt_1 + ', upperName=' + this.upperName_1 + ', upperInt=' + this.upperInt_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.lowerName_1);
        result = imul(result, 31) + this.lowerInt_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.upperName_1) | 0;
        result = imul(result, 31) + this.upperInt_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Scale()))
          return false;
        if (!(this.lowerName_1 === other.lowerName_1))
          return false;
        if (!(this.lowerInt_1 === other.lowerInt_1))
          return false;
        if (!(this.upperName_1 === other.upperName_1))
          return false;
        if (!(this.upperInt_1 === other.upperInt_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Question_Type_Scale_uod5l6_k$(seen0, lowerName, lowerInt, upperName, upperInt, serializationConstructorMarker) {
        if (!(5 === (5 & seen0))) {
          throwMissingFieldException(seen0, 5, $serializer_getInstance_7().descriptor_1);
        }
        var $this = createThis(this);
        $this.lowerName_1 = lowerName;
        if (0 === (seen0 & 2))
          $this.lowerInt_1 = 1;
        else
          $this.lowerInt_1 = lowerInt;
        $this.upperName_1 = upperName;
        if (0 === (seen0 & 8))
          $this.upperInt_1 = 5;
        else
          $this.upperInt_1 = upperInt;
        return $this;
      }
    }
    initMetadataForClass($, 'Scale', VOID, VOID, [Type()], VOID, VOID, {0: $serializer_getInstance_7});
    ScaleClass = $;
  }
  return ScaleClass;
}
var FreeNumberClass;
function FreeNumber() {
  if (FreeNumberClass === VOID) {
    class $ {
      constructor(prefix, postfix, integersOnly) {
        prefix = prefix === VOID ? '' : prefix;
        postfix = postfix === VOID ? '' : postfix;
        this.prefix_1 = prefix;
        this.postfix_1 = postfix;
        this.integersOnly_1 = integersOnly;
      }
      toString() {
        return 'FreeNumber(prefix=' + this.prefix_1 + ', postfix=' + this.postfix_1 + ', integersOnly=' + this.integersOnly_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.prefix_1);
        result = imul(result, 31) + getStringHashCode(this.postfix_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.integersOnly_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FreeNumber()))
          return false;
        if (!(this.prefix_1 === other.prefix_1))
          return false;
        if (!(this.postfix_1 === other.postfix_1))
          return false;
        if (!(this.integersOnly_1 === other.integersOnly_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Question_Type_FreeNumber_pg0hv0_k$(seen0, prefix, postfix, integersOnly, serializationConstructorMarker) {
        if (!(4 === (4 & seen0))) {
          throwMissingFieldException(seen0, 4, $serializer_getInstance_8().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.prefix_1 = '';
        else
          $this.prefix_1 = prefix;
        if (0 === (seen0 & 2))
          $this.postfix_1 = '';
        else
          $this.postfix_1 = postfix;
        $this.integersOnly_1 = integersOnly;
        return $this;
      }
    }
    initMetadataForClass($, 'FreeNumber', VOID, VOID, [Type()], VOID, VOID, {0: $serializer_getInstance_8});
    FreeNumberClass = $;
  }
  return FreeNumberClass;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        var tmp = getKClass(Type());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = [getKClass(FreeNumber()), getKClass(FreeText()), getKClass(MultipleChoice()), getKClass(Scale()), getKClass(SingleChoice())];
        var tmp_1 = $serializer_getInstance_8();
        var tmp_2 = FreeText_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = [];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_3 = [tmp_1, ObjectSerializer().new_kotlinx_serialization_internal_ObjectSerializer_ezfnxd_k$('org.thecommunitygroupinc.cares.Question.Type.FreeText', tmp_2, tmp$ret$3), $serializer_getInstance_6(), $serializer_getInstance_7(), $serializer_getInstance_5()];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$9 = [];
        return SealedClassSerializer().new_kotlinx_serialization_SealedClassSerializer_bm9rfz_k$('org.thecommunitygroupinc.cares.Question.Type', tmp, tmp_0, tmp_3, tmp$ret$9);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_8;
function Companion_getInstance_11() {
  return Companion_instance_8;
}
function Question$ShowCondition$Companion$$childSerializers$_anonymous__dxu2vq() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      constructor() {
        Companion_instance_9 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, Question$ShowCondition$Companion$$childSerializers$_anonymous__dxu2vq)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_9();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_9;
function Companion_getInstance_12() {
  if (Companion_instance_9 === VOID)
    new (Companion_8())();
  return Companion_instance_9;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Question.ShowCondition', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('otherQuestion', false);
        tmp0_serialDesc.addElement_5pzumi_k$('answerIsOneOf', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_nxfdt7_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_12().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_4(), new (ID_1())(value.otherQuestion_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.answerIsOneOf_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_nxfdt7_k$(encoder, value instanceof ShowCondition() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp7_cached = Companion_getInstance_12().$childSerializers_1;
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_4();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_1())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_4();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_1())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ShowCondition().new_org_thecommunitygroupinc_cares_Question_ShowCondition_mw3ntc_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_12().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_4(), tmp0_cached[1].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_9() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
function Question$Companion$$childSerializers$_anonymous__ia13ng() {
  return Companion_instance_8.serializer_9w0wvi_k$();
}
var IDClass_0;
function ID_1() {
  if (IDClass_0 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_0(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_0(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_1(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_0(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_0(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_4});
    IDClass_0 = $;
  }
  return IDClass_0;
}
var TypeClass;
function Type() {
  if (TypeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Type', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_11});
    TypeClass = $;
  }
  return TypeClass;
}
var ShowConditionClass;
function ShowCondition() {
  if (ShowConditionClass === VOID) {
    class $ {
      constructor(otherQuestion, answerIsOneOf) {
        Companion_getInstance_12();
        this.otherQuestion_1 = otherQuestion;
        this.answerIsOneOf_1 = answerIsOneOf;
      }
      toString() {
        return 'ShowCondition(otherQuestion=' + ID__toString_impl_y5caka_0(this.otherQuestion_1) + ', answerIsOneOf=' + toString(this.answerIsOneOf_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_1(this.otherQuestion_1);
        result = imul(result, 31) + hashCode(this.answerIsOneOf_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ShowCondition()))
          return false;
        if (!equals(this.otherQuestion_1, other.otherQuestion_1))
          return false;
        if (!equals(this.answerIsOneOf_1, other.answerIsOneOf_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Question_ShowCondition_mw3ntc_k$(seen0, otherQuestion, answerIsOneOf, serializationConstructorMarker) {
        Companion_getInstance_12();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_9().descriptor_1);
        }
        var $this = createThis(this);
        $this.otherQuestion_1 = otherQuestion;
        $this.answerIsOneOf_1 = answerIsOneOf;
        return $this;
      }
    }
    initMetadataForClass($, 'ShowCondition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
    ShowConditionClass = $;
  }
  return ShowConditionClass;
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      constructor() {
        Companion_instance_10 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, lazy(tmp_0, Question$Companion$$childSerializers$_anonymous__ia13ng), null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_10();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_10;
function Companion_getInstance_13() {
  if (Companion_instance_10 === VOID)
    new (Companion_9())();
  return Companion_instance_10;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.Question', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('question', false);
        tmp0_serialDesc.addElement_5pzumi_k$('item', true);
        tmp0_serialDesc.addElement_5pzumi_k$('type', false);
        tmp0_serialDesc.addElement_5pzumi_k$('optional', true);
        tmp0_serialDesc.addElement_5pzumi_k$('employerMaySeeResponse', true);
        tmp0_serialDesc.addElement_5pzumi_k$('showCondition', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_2u1qk1_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_13().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_4(), new (ID_1())(value._id_1));
        }
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.question_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.item_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, StringSerializer_getInstance(), value.item_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.type_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.optional_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 4, value.optional_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.employerMaySeeResponse_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 5, value.employerMaySeeResponse_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.showCondition_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, $serializer_getInstance_9(), value.showCondition_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_2u1qk1_k$(encoder, value instanceof Question() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = false;
        var tmp9_local5 = false;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_13().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_4();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_1())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp12_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_9(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = $serializer_getInstance_4();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (ID_1())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp12_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_9(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Question().new_org_thecommunitygroupinc_cares_Question_egmt8_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_13().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_4(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[3].get_value_j01efc_k$(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_9())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_10() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var QuestionClass;
function Question() {
  if (QuestionClass === VOID) {
    class $ {
      constructor(_id, question, item, type, optional, employerMaySeeResponse, showCondition) {
        Companion_getInstance_13();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        item = item === VOID ? null : item;
        optional = optional === VOID ? false : optional;
        employerMaySeeResponse = employerMaySeeResponse === VOID ? false : employerMaySeeResponse;
        showCondition = showCondition === VOID ? null : showCondition;
        this._id_1 = _id;
        this.question_1 = question;
        this.item_1 = item;
        this.type_1 = type;
        this.optional_1 = optional;
        this.employerMaySeeResponse_1 = employerMaySeeResponse;
        this.showCondition_1 = showCondition;
      }
      get__id_qrwty2_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_1())(this.get__id_qrwty2_k$());
      }
      toString() {
        return 'Question(_id=' + ID__toString_impl_y5caka_0(this._id_1) + ', question=' + this.question_1 + ', item=' + this.item_1 + ', type=' + toString(this.type_1) + ', optional=' + this.optional_1 + ', employerMaySeeResponse=' + this.employerMaySeeResponse_1 + ', showCondition=' + toString_0(this.showCondition_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_1(this._id_1);
        result = imul(result, 31) + getStringHashCode(this.question_1) | 0;
        result = imul(result, 31) + (this.item_1 == null ? 0 : getStringHashCode(this.item_1)) | 0;
        result = imul(result, 31) + hashCode(this.type_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.optional_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.employerMaySeeResponse_1) | 0;
        result = imul(result, 31) + (this.showCondition_1 == null ? 0 : this.showCondition_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Question()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!(this.question_1 === other.question_1))
          return false;
        if (!(this.item_1 == other.item_1))
          return false;
        if (!equals(this.type_1, other.type_1))
          return false;
        if (!(this.optional_1 === other.optional_1))
          return false;
        if (!(this.employerMaySeeResponse_1 === other.employerMaySeeResponse_1))
          return false;
        if (!equals(this.showCondition_1, other.showCondition_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_Question_egmt8_k$(seen0, _id, question, item, type, optional, employerMaySeeResponse, showCondition, serializationConstructorMarker) {
        Companion_getInstance_13();
        if (!(10 === (10 & seen0))) {
          throwMissingFieldException(seen0, 10, $serializer_getInstance_10().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_0(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.question_1 = question;
        if (0 === (seen0 & 4))
          $this.item_1 = null;
        else
          $this.item_1 = item;
        $this.type_1 = type;
        if (0 === (seen0 & 16))
          $this.optional_1 = false;
        else
          $this.optional_1 = optional;
        if (0 === (seen0 & 32))
          $this.employerMaySeeResponse_1 = false;
        else
          $this.employerMaySeeResponse_1 = employerMaySeeResponse;
        if (0 === (seen0 & 64))
          $this.showCondition_1 = null;
        else
          $this.showCondition_1 = showCondition;
        return $this;
      }
    }
    initMetadataForClass($, 'Question', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_10});
    QuestionClass = $;
  }
  return QuestionClass;
}
function QuestionResponse$Demographic$Companion$$childSerializers$_anonymous__bjpria() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_0());
}
function QuestionResponse$Demographic$Companion$$childSerializers$_anonymous__bjpria_0() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_1());
}
function QuestionResponse$Demographic$Companion$$childSerializers$_anonymous__bjpria_1() {
  return Companion_getInstance_1().serializer_9w0wvi_k$();
}
function QuestionResponse$Demographic$Companion$$childSerializers$_anonymous__bjpria_2() {
  return Companion_getInstance_2().serializer_9w0wvi_k$();
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      constructor() {
        Companion_instance_11 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, QuestionResponse$Demographic$Companion$$childSerializers$_anonymous__bjpria);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, QuestionResponse$Demographic$Companion$$childSerializers$_anonymous__bjpria_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, QuestionResponse$Demographic$Companion$$childSerializers$_anonymous__bjpria_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [tmp_1, tmp_3, null, tmp_5, lazy(tmp_6, QuestionResponse$Demographic$Companion$$childSerializers$_anonymous__bjpria_2), null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_11();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_11;
function Companion_getInstance_14() {
  if (Companion_instance_11 === VOID)
    new (Companion_10())();
  return Companion_instance_11;
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.QuestionResponse.Demographic', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('supportingEmployers', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (FrozenDenormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('supportingGrants', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (FrozenDenormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('takerEmployer', true);
        tmp0_serialDesc.addElement_5pzumi_k$('income', true);
        tmp0_serialDesc.addElement_5pzumi_k$('leadershipLevel', true);
        tmp0_serialDesc.addElement_5pzumi_k$('familySize', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (FrozenDenormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('city', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (FrozenDenormalized())());
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_95zyqb_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_14().$childSerializers_1;
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.supportingEmployers_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.supportingEmployers_1);
        }
        var tmp_0;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1)) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$1 = emptySet();
          tmp_0 = !equals(value.supportingGrants_1, tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.supportingGrants_1);
        }
        var tmp_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2)) {
          tmp_1 = true;
        } else {
          var tmp_2 = value.takerEmployer_1;
          tmp_1 = !((tmp_2 == null ? null : new (ID())(tmp_2)) == null);
        }
        if (tmp_1) {
          var tmp_3 = $serializer_getInstance_0();
          var tmp_4 = value.takerEmployer_1;
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, tmp_3, tmp_4 == null ? null : new (ID())(tmp_4));
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.income_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.income_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.leadershipLevel_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.leadershipLevel_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.familySize_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, IntSerializer_getInstance(), value.familySize_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.city_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 6, value.city_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_95zyqb_k$(encoder, value instanceof Demographic() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_14().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp12_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp12_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp = $serializer_getInstance_0();
          var tmp_0 = tmp6_local2;
          var tmp_1 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp, tmp_0 == null ? null : new (ID())(tmp_0));
          tmp6_local2 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp12_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, tmp12_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp12_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp12_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_2 = $serializer_getInstance_0();
                var tmp_3 = tmp6_local2;
                var tmp_4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp_2, tmp_3 == null ? null : new (ID())(tmp_3));
                tmp6_local2 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp12_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, tmp12_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Demographic().new_org_thecommunitygroupinc_cares_QuestionResponse_Demographic_7ynr07_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_14().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [tmp0_cached[0].get_value_j01efc_k$(), tmp0_cached[1].get_value_j01efc_k$(), get_nullable($serializer_getInstance_0()), get_nullable(tmp0_cached[3].get_value_j01efc_k$()), get_nullable(tmp0_cached[4].get_value_j01efc_k$()), get_nullable(IntSerializer_getInstance()), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_11() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
function _ID___init__impl__k1lb7e_1(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_1($this) {
  return $this;
}
function ID__toString_impl_y5caka_1($this) {
  return _ID___get_raw__impl__92g6u5_1($this).toString();
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_12();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_12;
function Companion_getInstance_15() {
  return Companion_instance_12;
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.QuestionResponse.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(QuestionResponse())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_rl7yff_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_1(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_rl7yff_k$(encoder, value instanceof ID_2() ? value.raw_1 : THROW_CCE());
      }
      deserialize_uic2me_k$(decoder) {
        return _ID___init__impl__k1lb7e_1(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_2())(this.deserialize_uic2me_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_12() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
function ID__hashCode_impl_f4lulz_2($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_1($this, other) {
  if (!(other instanceof ID_2()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_1($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_2())(other instanceof ID_2() ? other.raw_1 : THROW_CCE()));
}
function QuestionResponse$Companion$$childSerializers$_anonymous__rs8il9() {
  return Companion_getInstance_3().serializer_9w0wvi_k$();
}
function QuestionResponse$Companion$$childSerializers$_anonymous__rs8il9_0() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var DemographicClass;
function Demographic() {
  if (DemographicClass === VOID) {
    class $ {
      constructor(supportingEmployers, supportingGrants, takerEmployer, income, leadershipLevel, familySize, city) {
        Companion_getInstance_14();
        var tmp;
        if (supportingEmployers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = supportingEmployers;
        }
        supportingEmployers = tmp;
        var tmp_0;
        if (supportingGrants === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = supportingGrants;
        }
        supportingGrants = tmp_0;
        takerEmployer = takerEmployer === VOID ? null : takerEmployer;
        income = income === VOID ? null : income;
        leadershipLevel = leadershipLevel === VOID ? null : leadershipLevel;
        familySize = familySize === VOID ? null : familySize;
        city = city === VOID ? '' : city;
        this.supportingEmployers_1 = supportingEmployers;
        this.supportingGrants_1 = supportingGrants;
        this.takerEmployer_1 = takerEmployer;
        this.income_1 = income;
        this.leadershipLevel_1 = leadershipLevel;
        this.familySize_1 = familySize;
        this.city_1 = city;
      }
      toString() {
        var tmp = toString(this.supportingEmployers_1);
        var tmp_0 = toString(this.supportingGrants_1);
        var tmp_1 = this.takerEmployer_1;
        return 'Demographic(supportingEmployers=' + tmp + ', supportingGrants=' + tmp_0 + ', takerEmployer=' + toString_0(tmp_1 == null ? null : new (ID())(tmp_1)) + ', income=' + toString_0(this.income_1) + ', leadershipLevel=' + toString_0(this.leadershipLevel_1) + ', familySize=' + this.familySize_1 + ', city=' + this.city_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.supportingEmployers_1);
        result = imul(result, 31) + hashCode(this.supportingGrants_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.takerEmployer_1;
        if ((tmp_1 == null ? null : new (ID())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ID__hashCode_impl_f4lulz(this.takerEmployer_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + (this.income_1 == null ? 0 : this.income_1.hashCode()) | 0;
        result = imul(result, 31) + (this.leadershipLevel_1 == null ? 0 : this.leadershipLevel_1.hashCode()) | 0;
        result = imul(result, 31) + (this.familySize_1 == null ? 0 : this.familySize_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.city_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Demographic()))
          return false;
        if (!equals(this.supportingEmployers_1, other.supportingEmployers_1))
          return false;
        if (!equals(this.supportingGrants_1, other.supportingGrants_1))
          return false;
        var tmp = this.takerEmployer_1;
        var tmp_0 = tmp == null ? null : new (ID())(tmp);
        var tmp_1 = other.takerEmployer_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ID())(tmp_1)))
          return false;
        if (!equals(this.income_1, other.income_1))
          return false;
        if (!equals(this.leadershipLevel_1, other.leadershipLevel_1))
          return false;
        if (!(this.familySize_1 == other.familySize_1))
          return false;
        if (!(this.city_1 === other.city_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_QuestionResponse_Demographic_7ynr07_k$(seen0, supportingEmployers, supportingGrants, takerEmployer, income, leadershipLevel, familySize, city, serializationConstructorMarker) {
        Companion_getInstance_14();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_11().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.supportingEmployers_1 = emptySet();
        } else
          $this.supportingEmployers_1 = supportingEmployers;
        if (0 === (seen0 & 2)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_0.supportingGrants_1 = emptySet();
        } else
          $this.supportingGrants_1 = supportingGrants;
        if (0 === (seen0 & 4))
          $this.takerEmployer_1 = null;
        else
          $this.takerEmployer_1 = takerEmployer;
        if (0 === (seen0 & 8))
          $this.income_1 = null;
        else
          $this.income_1 = income;
        if (0 === (seen0 & 16))
          $this.leadershipLevel_1 = null;
        else
          $this.leadershipLevel_1 = leadershipLevel;
        if (0 === (seen0 & 32))
          $this.familySize_1 = null;
        else
          $this.familySize_1 = familySize;
        if (0 === (seen0 & 64))
          $this.city_1 = '';
        else
          $this.city_1 = city;
        return $this;
      }
    }
    initMetadataForClass($, 'Demographic', Demographic, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
    DemographicClass = $;
  }
  return DemographicClass;
}
var IDClass_1;
function ID_2() {
  if (IDClass_1 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_1(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_1(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_2(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_1(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_1(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_12});
    IDClass_1 = $;
  }
  return IDClass_1;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      constructor() {
        Companion_instance_13 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, QuestionResponse$Companion$$childSerializers$_anonymous__rs8il9);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, tmp_1, null, null, null, null, null, null, null, lazy(tmp_2, QuestionResponse$Companion$$childSerializers$_anonymous__rs8il9_0), null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_13();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_13;
function Companion_getInstance_16() {
  if (Companion_instance_13 === VOID)
    new (Companion_12())();
  return Companion_instance_13;
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.QuestionResponse', this, 14);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('survey', false);
        tmp0_serialDesc.addElement_5pzumi_k$('question', false);
        tmp0_serialDesc.addElement_5pzumi_k$('takerType', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (FrozenDenormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('takerId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('takerIteration', true);
        tmp0_serialDesc.addElement_5pzumi_k$('employerMaySeeResponse', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (FrozenDenormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('demographic', true);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (FrozenDenormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('at', true);
        tmp0_serialDesc.addElement_5pzumi_k$('answerFreeText', true);
        tmp0_serialDesc.addElement_5pzumi_k$('answerSingleChoice', true);
        tmp0_serialDesc.addElement_5pzumi_k$('answerMultipleChoice', true);
        tmp0_serialDesc.addElement_5pzumi_k$('answerScale', true);
        tmp0_serialDesc.addElement_5pzumi_k$('answerFreeNumber', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['survey', 'question', 'takerId', 'takerIteration'], IndexUniqueness_Unique_getInstance()));
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['question', 'demographic.takerEmployer']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_tzym8g_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_16().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_1(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_12(), new (ID_2())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_2(), new (ID_0())(value.survey_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_4(), new (ID_1())(value.question_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.takerType_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, UuidSerializer_getInstance(), value.takerId_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.takerIteration_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 5, value.takerIteration_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.employerMaySeeResponse_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 6, value.employerMaySeeResponse_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !value.demographic_1.equals(new (Demographic())())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 7, $serializer_getInstance_11(), value.demographic_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8) ? true : !value.at_1.equals(now())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 8, InstantSerializer_getInstance(), value.at_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 9) ? true : !(value.answerFreeText_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 9, StringSerializer_getInstance(), value.answerFreeText_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 10) ? true : !(value.answerSingleChoice_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 10, StringSerializer_getInstance(), value.answerSingleChoice_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 11) ? true : !(value.answerMultipleChoice_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 11, tmp2_cached[11].get_value_j01efc_k$(), value.answerMultipleChoice_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 12) ? true : !(value.answerScale_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 12, IntSerializer_getInstance(), value.answerScale_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 13) ? true : !(value.answerFreeNumber_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 13, DoubleSerializer_getInstance(), value.answerFreeNumber_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_tzym8g_k$(encoder, value instanceof QuestionResponse() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = 0;
        var tmp10_local6 = false;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp19_cached = Companion_getInstance_16().$childSerializers_1;
        if (tmp18_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_12();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_2())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_0())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          var tmp_5 = $serializer_getInstance_4();
          var tmp_6 = tmp6_local2;
          var tmp_7 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_5, tmp_6 == null ? null : new (ID_1())(tmp_6));
          tmp6_local2 = tmp_7 == null ? null : tmp_7.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp19_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, UuidSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp18_input.decodeIntElement_941u6a_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp18_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, $serializer_getInstance_11(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, InstantSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 11, tmp19_cached[11].get_value_j01efc_k$(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 12, IntSerializer_getInstance(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 13, DoubleSerializer_getInstance(), tmp17_local13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp18_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_8 = $serializer_getInstance_12();
                var tmp_9 = tmp4_local0;
                var tmp_10 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_8, tmp_9 == null ? null : new (ID_2())(tmp_9));
                tmp4_local0 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_11 = $serializer_getInstance_2();
                var tmp_12 = tmp5_local1;
                var tmp_13 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_11, tmp_12 == null ? null : new (ID_0())(tmp_12));
                tmp5_local1 = tmp_13 == null ? null : tmp_13.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                var tmp_14 = $serializer_getInstance_4();
                var tmp_15 = tmp6_local2;
                var tmp_16 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp_14, tmp_15 == null ? null : new (ID_1())(tmp_15));
                tmp6_local2 = tmp_16 == null ? null : tmp_16.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp19_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, UuidSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp18_input.decodeIntElement_941u6a_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp18_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 7, $serializer_getInstance_11(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp18_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 8, InstantSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 11, tmp19_cached[11].get_value_j01efc_k$(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 12, IntSerializer_getInstance(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp18_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 13, DoubleSerializer_getInstance(), tmp17_local13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp18_input.endStructure_1xqz0n_k$(tmp0_desc);
        return QuestionResponse().new_org_thecommunitygroupinc_cares_QuestionResponse_f0ntx9_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_16().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_12(), $serializer_getInstance_2(), $serializer_getInstance_4(), tmp0_cached[3].get_value_j01efc_k$(), UuidSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), $serializer_getInstance_11(), InstantSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[11].get_value_j01efc_k$()), get_nullable(IntSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_13() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
var QuestionResponseClass;
function QuestionResponse() {
  if (QuestionResponseClass === VOID) {
    class $ {
      constructor(_id, survey, question, takerType, takerId, takerIteration, employerMaySeeResponse, demographic, at, answerFreeText, answerSingleChoice, answerMultipleChoice, answerScale, answerFreeNumber) {
        Companion_getInstance_16();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_1(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        takerIteration = takerIteration === VOID ? 0 : takerIteration;
        employerMaySeeResponse = employerMaySeeResponse === VOID ? false : employerMaySeeResponse;
        demographic = demographic === VOID ? new (Demographic())() : demographic;
        at = at === VOID ? now() : at;
        answerFreeText = answerFreeText === VOID ? null : answerFreeText;
        answerSingleChoice = answerSingleChoice === VOID ? null : answerSingleChoice;
        answerMultipleChoice = answerMultipleChoice === VOID ? null : answerMultipleChoice;
        answerScale = answerScale === VOID ? null : answerScale;
        answerFreeNumber = answerFreeNumber === VOID ? null : answerFreeNumber;
        this._id_1 = _id;
        this.survey_1 = survey;
        this.question_1 = question;
        this.takerType_1 = takerType;
        this.takerId_1 = takerId;
        this.takerIteration_1 = takerIteration;
        this.employerMaySeeResponse_1 = employerMaySeeResponse;
        this.demographic_1 = demographic;
        this.at_1 = at;
        this.answerFreeText_1 = answerFreeText;
        this.answerSingleChoice_1 = answerSingleChoice;
        this.answerMultipleChoice_1 = answerMultipleChoice;
        this.answerScale_1 = answerScale;
        this.answerFreeNumber_1 = answerFreeNumber;
      }
      get__id_qoe1d3_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_2())(this.get__id_qoe1d3_k$());
      }
      copy_i924gw_k$(_id, survey, question, takerType, takerId, takerIteration, employerMaySeeResponse, demographic, at, answerFreeText, answerSingleChoice, answerMultipleChoice, answerScale, answerFreeNumber) {
        return new (QuestionResponse())(_id, survey, question, takerType, takerId, takerIteration, employerMaySeeResponse, demographic, at, answerFreeText, answerSingleChoice, answerMultipleChoice, answerScale, answerFreeNumber);
      }
      copy$default_9dsjvp_k$(_id, survey, question, takerType, takerId, takerIteration, employerMaySeeResponse, demographic, at, answerFreeText, answerSingleChoice, answerMultipleChoice, answerScale, answerFreeNumber, $super) {
        _id = _id === VOID ? this._id_1 : _id;
        survey = survey === VOID ? this.survey_1 : survey;
        question = question === VOID ? this.question_1 : question;
        takerType = takerType === VOID ? this.takerType_1 : takerType;
        takerId = takerId === VOID ? this.takerId_1 : takerId;
        takerIteration = takerIteration === VOID ? this.takerIteration_1 : takerIteration;
        employerMaySeeResponse = employerMaySeeResponse === VOID ? this.employerMaySeeResponse_1 : employerMaySeeResponse;
        demographic = demographic === VOID ? this.demographic_1 : demographic;
        at = at === VOID ? this.at_1 : at;
        answerFreeText = answerFreeText === VOID ? this.answerFreeText_1 : answerFreeText;
        answerSingleChoice = answerSingleChoice === VOID ? this.answerSingleChoice_1 : answerSingleChoice;
        answerMultipleChoice = answerMultipleChoice === VOID ? this.answerMultipleChoice_1 : answerMultipleChoice;
        answerScale = answerScale === VOID ? this.answerScale_1 : answerScale;
        answerFreeNumber = answerFreeNumber === VOID ? this.answerFreeNumber_1 : answerFreeNumber;
        return $super === VOID ? this.copy_i924gw_k$(_id, survey, question, takerType, takerId, takerIteration, employerMaySeeResponse, demographic, at, answerFreeText, answerSingleChoice, answerMultipleChoice, answerScale, answerFreeNumber) : $super.copy_i924gw_k$.call(this, new (ID_2())(_id), new (ID_0())(survey), new (ID_1())(question), takerType, takerId, takerIteration, employerMaySeeResponse, demographic, at, answerFreeText, answerSingleChoice, answerMultipleChoice, answerScale, answerFreeNumber);
      }
      toString() {
        return 'QuestionResponse(_id=' + ID__toString_impl_y5caka_1(this._id_1) + ', survey=' + ID__toString_impl_y5caka(this.survey_1) + ', question=' + ID__toString_impl_y5caka_0(this.question_1) + ', takerType=' + this.takerType_1.toString() + ', takerId=' + this.takerId_1.toString() + ', takerIteration=' + this.takerIteration_1 + ', employerMaySeeResponse=' + this.employerMaySeeResponse_1 + ', demographic=' + this.demographic_1.toString() + ', at=' + this.at_1.toString() + ', answerFreeText=' + this.answerFreeText_1 + ', answerSingleChoice=' + this.answerSingleChoice_1 + ', answerMultipleChoice=' + toString_0(this.answerMultipleChoice_1) + ', answerScale=' + this.answerScale_1 + ', answerFreeNumber=' + this.answerFreeNumber_1 + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_2(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_0(this.survey_1) | 0;
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_1(this.question_1) | 0;
        result = imul(result, 31) + this.takerType_1.hashCode() | 0;
        result = imul(result, 31) + this.takerId_1.hashCode() | 0;
        result = imul(result, 31) + this.takerIteration_1 | 0;
        result = imul(result, 31) + getBooleanHashCode(this.employerMaySeeResponse_1) | 0;
        result = imul(result, 31) + this.demographic_1.hashCode() | 0;
        result = imul(result, 31) + this.at_1.hashCode() | 0;
        result = imul(result, 31) + (this.answerFreeText_1 == null ? 0 : getStringHashCode(this.answerFreeText_1)) | 0;
        result = imul(result, 31) + (this.answerSingleChoice_1 == null ? 0 : getStringHashCode(this.answerSingleChoice_1)) | 0;
        result = imul(result, 31) + (this.answerMultipleChoice_1 == null ? 0 : hashCode(this.answerMultipleChoice_1)) | 0;
        result = imul(result, 31) + (this.answerScale_1 == null ? 0 : this.answerScale_1) | 0;
        result = imul(result, 31) + (this.answerFreeNumber_1 == null ? 0 : getNumberHashCode(this.answerFreeNumber_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof QuestionResponse()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.survey_1, other.survey_1))
          return false;
        if (!equals(this.question_1, other.question_1))
          return false;
        if (!this.takerType_1.equals(other.takerType_1))
          return false;
        if (!this.takerId_1.equals(other.takerId_1))
          return false;
        if (!(this.takerIteration_1 === other.takerIteration_1))
          return false;
        if (!(this.employerMaySeeResponse_1 === other.employerMaySeeResponse_1))
          return false;
        if (!this.demographic_1.equals(other.demographic_1))
          return false;
        if (!this.at_1.equals(other.at_1))
          return false;
        if (!(this.answerFreeText_1 == other.answerFreeText_1))
          return false;
        if (!(this.answerSingleChoice_1 == other.answerSingleChoice_1))
          return false;
        if (!equals(this.answerMultipleChoice_1, other.answerMultipleChoice_1))
          return false;
        if (!(this.answerScale_1 == other.answerScale_1))
          return false;
        if (!equals(this.answerFreeNumber_1, other.answerFreeNumber_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_QuestionResponse_f0ntx9_k$(seen0, _id, survey, question, takerType, takerId, takerIteration, employerMaySeeResponse, demographic, at, answerFreeText, answerSingleChoice, answerMultipleChoice, answerScale, answerFreeNumber, serializationConstructorMarker) {
        Companion_getInstance_16();
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, $serializer_getInstance_13().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_1(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.survey_1 = survey;
        $this.question_1 = question;
        $this.takerType_1 = takerType;
        $this.takerId_1 = takerId;
        if (0 === (seen0 & 32))
          $this.takerIteration_1 = 0;
        else
          $this.takerIteration_1 = takerIteration;
        if (0 === (seen0 & 64))
          $this.employerMaySeeResponse_1 = false;
        else
          $this.employerMaySeeResponse_1 = employerMaySeeResponse;
        if (0 === (seen0 & 128))
          $this.demographic_1 = new (Demographic())();
        else
          $this.demographic_1 = demographic;
        if (0 === (seen0 & 256))
          $this.at_1 = now();
        else
          $this.at_1 = at;
        if (0 === (seen0 & 512))
          $this.answerFreeText_1 = null;
        else
          $this.answerFreeText_1 = answerFreeText;
        if (0 === (seen0 & 1024))
          $this.answerSingleChoice_1 = null;
        else
          $this.answerSingleChoice_1 = answerSingleChoice;
        if (0 === (seen0 & 2048))
          $this.answerMultipleChoice_1 = null;
        else
          $this.answerMultipleChoice_1 = answerMultipleChoice;
        if (0 === (seen0 & 4096))
          $this.answerScale_1 = null;
        else
          $this.answerScale_1 = answerScale;
        if (0 === (seen0 & 8192))
          $this.answerFreeNumber_1 = null;
        else
          $this.answerFreeNumber_1 = answerFreeNumber;
        return $this;
      }
    }
    initMetadataForClass($, 'QuestionResponse', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_13});
    QuestionResponseClass = $;
  }
  return QuestionResponseClass;
}
function _ID___init__impl__k1lb7e_2(raw) {
  return raw;
}
function _ID___get_raw__impl__92g6u5_2($this) {
  return $this;
}
function ID__toString_impl_y5caka_2($this) {
  return _ID___get_raw__impl__92g6u5_2($this).toString();
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_14();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_14;
function Companion_getInstance_17() {
  return Companion_instance_14;
}
var $serializerClass_11;
function $serializer_11() {
  if ($serializerClass_11 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_11 = this;
        var tmp0_serialDesc = new (InlineClassDescriptor())('org.thecommunitygroupinc.cares.SurveyProgress.ID', this);
        tmp0_serialDesc.addElement_5pzumi_k$('raw', false);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (References())(getKClass(SurveyProgress())));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_67v445_k$(encoder, value) {
        var tmp0_inlineEncoder = encoder.encodeInline_wxp5pu_k$(this.descriptor_1);
        if (tmp0_inlineEncoder == null)
          null;
        else {
          tmp0_inlineEncoder.encodeSerializableValue_3uuzip_k$(UuidSerializer_getInstance(), _ID___get_raw__impl__92g6u5_2(value));
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_67v445_k$(encoder, value instanceof ID_3() ? value.raw_1 : THROW_CCE());
      }
      deserialize_dxfaw6_k$(decoder) {
        return _ID___init__impl__k1lb7e_2(decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(UuidSerializer_getInstance()));
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ID_3())(this.deserialize_dxfaw6_k$(decoder));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_11 = $;
  }
  return $serializerClass_11;
}
var $serializer_instance_11;
function $serializer_getInstance_14() {
  if ($serializer_instance_11 === VOID)
    new ($serializer_11())();
  return $serializer_instance_11;
}
function ID__hashCode_impl_f4lulz_3($this) {
  return $this.hashCode();
}
function ID__equals_impl_g09z1p_2($this, other) {
  if (!(other instanceof ID_3()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function ID__compareTo_impl_ru1vns_2($this, other) {
  return $this.compareTo_44yzl0_k$(new (ID_3())(other instanceof ID_3() ? other.raw_1 : THROW_CCE()));
}
function SurveyProgress$Companion$$childSerializers$_anonymous__6mwscd() {
  return Companion_getInstance_3().serializer_9w0wvi_k$();
}
var IDClass_2;
function ID_3() {
  if (IDClass_2 === VOID) {
    class $ {
      constructor(raw) {
        this.raw_1 = raw;
      }
      get_raw_18ix4x_k$() {
        return _ID___get_raw__impl__92g6u5_2(this.raw_1);
      }
      toString() {
        return ID__toString_impl_y5caka_2(this.raw_1);
      }
      hashCode() {
        return ID__hashCode_impl_f4lulz_3(this.raw_1);
      }
      equals(other) {
        return ID__equals_impl_g09z1p_2(this.raw_1, other);
      }
      compareTo_hpufkf_k$(other) {
        return ID__compareTo_impl_ru1vns_2(this, other);
      }
    }
    protoOf($).compareTo_44yzl0_k$ = compareTo;
    initMetadataForClass($, 'ID', VOID, VOID, [TypedId()], VOID, VOID, {0: $serializer_getInstance_14});
    IDClass_2 = $;
  }
  return IDClass_2;
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      constructor() {
        Companion_instance_15 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, lazy(tmp_0, SurveyProgress$Companion$$childSerializers$_anonymous__6mwscd), null, null, null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_15();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_15;
function Companion_getInstance_18() {
  if (Companion_instance_15 === VOID)
    new (Companion_14())();
  return Companion_instance_15;
}
var $serializerClass_12;
function $serializer_12() {
  if ($serializerClass_12 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_12 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.SurveyProgress', this, 8);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('survey', false);
        tmp0_serialDesc.addElement_5pzumi_k$('takerType', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (FrozenDenormalized())());
        tmp0_serialDesc.addElement_5pzumi_k$('takerId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('takerIteration', true);
        tmp0_serialDesc.addElement_5pzumi_k$('demographic', true);
        tmp0_serialDesc.addElement_5pzumi_k$('startedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('completedAt', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['survey', 'takerId', 'takerIteration'], IndexUniqueness_Unique_getInstance()));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_7ulv80_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_18().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value._id_1, _ID___init__impl__k1lb7e_2(Companion_getInstance_0().random_fimq0t_k$()))) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_14(), new (ID_3())(value._id_1));
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_2(), new (ID_0())(value.survey_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.takerType_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, UuidSerializer_getInstance(), value.takerId_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.takerIteration_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 4, value.takerIteration_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !value.demographic_1.equals(new (Demographic())())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, $serializer_getInstance_11(), value.demographic_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !value.startedAt_1.equals(now())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, InstantSerializer_getInstance(), value.startedAt_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !(value.completedAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 7, InstantSerializer_getInstance(), value.completedAt_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_7ulv80_k$(encoder, value instanceof SurveyProgress() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = 0;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp13_cached = Companion_getInstance_18().$childSerializers_1;
        if (tmp12_input.decodeSequentially_xlblqy_k$()) {
          var tmp = $serializer_getInstance_14();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (ID_3())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          var tmp_2 = $serializer_getInstance_2();
          var tmp_3 = tmp5_local1;
          var tmp_4 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_2, tmp_3 == null ? null : new (ID_0())(tmp_3));
          tmp5_local1 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp13_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, UuidSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp12_input.decodeIntElement_941u6a_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, $serializer_getInstance_11(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, InstantSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp12_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_5 = $serializer_getInstance_14();
                var tmp_6 = tmp4_local0;
                var tmp_7 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_5, tmp_6 == null ? null : new (ID_3())(tmp_6));
                tmp4_local0 = tmp_7 == null ? null : tmp_7.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                var tmp_8 = $serializer_getInstance_2();
                var tmp_9 = tmp5_local1;
                var tmp_10 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp_8, tmp_9 == null ? null : new (ID_0())(tmp_9));
                tmp5_local1 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp13_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, UuidSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp12_input.decodeIntElement_941u6a_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, $serializer_getInstance_11(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp12_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, InstantSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp12_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, InstantSerializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp12_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SurveyProgress().new_org_thecommunitygroupinc_cares_SurveyProgress_4i7voe_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_18().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_14(), $serializer_getInstance_2(), tmp0_cached[2].get_value_j01efc_k$(), UuidSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_11(), InstantSerializer_getInstance(), get_nullable(InstantSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_12 = $;
  }
  return $serializerClass_12;
}
var $serializer_instance_12;
function $serializer_getInstance_15() {
  if ($serializer_instance_12 === VOID)
    new ($serializer_12())();
  return $serializer_instance_12;
}
var SurveyProgressClass;
function SurveyProgress() {
  if (SurveyProgressClass === VOID) {
    class $ {
      constructor(_id, survey, takerType, takerId, takerIteration, demographic, startedAt, completedAt) {
        Companion_getInstance_18();
        _id = _id === VOID ? _ID___init__impl__k1lb7e_2(Companion_getInstance_0().random_fimq0t_k$()) : _id;
        takerIteration = takerIteration === VOID ? 0 : takerIteration;
        demographic = demographic === VOID ? new (Demographic())() : demographic;
        startedAt = startedAt === VOID ? now() : startedAt;
        completedAt = completedAt === VOID ? null : completedAt;
        this._id_1 = _id;
        this.survey_1 = survey;
        this.takerType_1 = takerType;
        this.takerId_1 = takerId;
        this.takerIteration_1 = takerIteration;
        this.demographic_1 = demographic;
        this.startedAt_1 = startedAt;
        this.completedAt_1 = completedAt;
      }
      get__id_fp2lfr_k$() {
        return this._id_1;
      }
      get__id_18jb1r_k$() {
        return new (ID_3())(this.get__id_fp2lfr_k$());
      }
      toString() {
        return 'SurveyProgress(_id=' + ID__toString_impl_y5caka_2(this._id_1) + ', survey=' + ID__toString_impl_y5caka(this.survey_1) + ', takerType=' + this.takerType_1.toString() + ', takerId=' + this.takerId_1.toString() + ', takerIteration=' + this.takerIteration_1 + ', demographic=' + this.demographic_1.toString() + ', startedAt=' + this.startedAt_1.toString() + ', completedAt=' + toString_0(this.completedAt_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz_3(this._id_1);
        result = imul(result, 31) + ID__hashCode_impl_f4lulz_0(this.survey_1) | 0;
        result = imul(result, 31) + this.takerType_1.hashCode() | 0;
        result = imul(result, 31) + this.takerId_1.hashCode() | 0;
        result = imul(result, 31) + this.takerIteration_1 | 0;
        result = imul(result, 31) + this.demographic_1.hashCode() | 0;
        result = imul(result, 31) + this.startedAt_1.hashCode() | 0;
        result = imul(result, 31) + (this.completedAt_1 == null ? 0 : this.completedAt_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SurveyProgress()))
          return false;
        if (!equals(this._id_1, other._id_1))
          return false;
        if (!equals(this.survey_1, other.survey_1))
          return false;
        if (!this.takerType_1.equals(other.takerType_1))
          return false;
        if (!this.takerId_1.equals(other.takerId_1))
          return false;
        if (!(this.takerIteration_1 === other.takerIteration_1))
          return false;
        if (!this.demographic_1.equals(other.demographic_1))
          return false;
        if (!this.startedAt_1.equals(other.startedAt_1))
          return false;
        if (!equals(this.completedAt_1, other.completedAt_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_SurveyProgress_4i7voe_k$(seen0, _id, survey, takerType, takerId, takerIteration, demographic, startedAt, completedAt, serializationConstructorMarker) {
        Companion_getInstance_18();
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_15().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = _ID___init__impl__k1lb7e_2(Companion_getInstance_0().random_fimq0t_k$());
        else
          $this._id_1 = _id;
        $this.survey_1 = survey;
        $this.takerType_1 = takerType;
        $this.takerId_1 = takerId;
        if (0 === (seen0 & 16))
          $this.takerIteration_1 = 0;
        else
          $this.takerIteration_1 = takerIteration;
        if (0 === (seen0 & 32))
          $this.demographic_1 = new (Demographic())();
        else
          $this.demographic_1 = demographic;
        if (0 === (seen0 & 64))
          $this.startedAt_1 = now();
        else
          $this.startedAt_1 = startedAt;
        if (0 === (seen0 & 128))
          $this.completedAt_1 = null;
        else
          $this.completedAt_1 = completedAt;
        return $this;
      }
    }
    initMetadataForClass($, 'SurveyProgress', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_15});
    SurveyProgressClass = $;
  }
  return SurveyProgressClass;
}
var FrozenDenormalizedClass;
function FrozenDenormalized() {
  if (FrozenDenormalizedClass === VOID) {
    class $ {
      equals(other) {
        if (!(other instanceof FrozenDenormalized()))
          return false;
        other instanceof FrozenDenormalized() || THROW_CCE();
        return true;
      }
      hashCode() {
        return 0;
      }
      toString() {
        return '@org.thecommunitygroupinc.cares.FrozenDenormalized(' + ')';
      }
    }
    initMetadataForClass($, 'FrozenDenormalized');
    FrozenDenormalizedClass = $;
  }
  return FrozenDenormalizedClass;
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_16();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_16;
function Companion_getInstance_19() {
  return Companion_instance_16;
}
var $serializerClass_13;
function $serializer_13() {
  if ($serializerClass_13 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_13 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.AnonymousSurvey', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('survey', false);
        tmp0_serialDesc.addElement_5pzumi_k$('employerName', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_j1dqvo_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance_3(), value.survey_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.employerName_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_j1dqvo_k$(encoder, value instanceof AnonymousSurvey() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AnonymousSurvey().new_org_thecommunitygroupinc_cares_AnonymousSurvey_1p8iub_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance_3(), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_13 = $;
  }
  return $serializerClass_13;
}
var $serializer_instance_13;
function $serializer_getInstance_16() {
  if ($serializer_instance_13 === VOID)
    new ($serializer_13())();
  return $serializer_instance_13;
}
var AnonymousSurveyClass;
function AnonymousSurvey() {
  if (AnonymousSurveyClass === VOID) {
    class $ {
      constructor(survey, employerName) {
        this.survey_1 = survey;
        this.employerName_1 = employerName;
      }
      toString() {
        return 'AnonymousSurvey(survey=' + this.survey_1.toString() + ', employerName=' + this.employerName_1 + ')';
      }
      hashCode() {
        var result = this.survey_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.employerName_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AnonymousSurvey()))
          return false;
        if (!this.survey_1.equals(other.survey_1))
          return false;
        if (!(this.employerName_1 === other.employerName_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_AnonymousSurvey_1p8iub_k$(seen0, survey, employerName, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_16().descriptor_1);
        }
        var $this = createThis(this);
        $this.survey_1 = survey;
        $this.employerName_1 = employerName;
        return $this;
      }
    }
    initMetadataForClass($, 'AnonymousSurvey', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
    AnonymousSurveyClass = $;
  }
  return AnonymousSurveyClass;
}
function AnonymousAnswers$Companion$$childSerializers$_anonymous__e05wke() {
  return new (ArrayListSerializer())($serializer_getInstance_13());
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      constructor() {
        Companion_instance_17 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, AnonymousAnswers$Companion$$childSerializers$_anonymous__e05wke)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_17();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_17;
function Companion_getInstance_20() {
  if (Companion_instance_17 === VOID)
    new (Companion_16())();
  return Companion_instance_17;
}
var $serializerClass_14;
function $serializer_14() {
  if ($serializerClass_14 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_14 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.AnonymousAnswers', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('takerId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('answers', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_oubxz1_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_20().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, UuidSerializer_getInstance(), value.takerId_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.answers_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_oubxz1_k$(encoder, value instanceof AnonymousAnswers() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp7_cached = Companion_getInstance_20().$childSerializers_1;
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AnonymousAnswers().new_org_thecommunitygroupinc_cares_AnonymousAnswers_g848qt_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_20().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_14 = $;
  }
  return $serializerClass_14;
}
var $serializer_instance_14;
function $serializer_getInstance_17() {
  if ($serializer_instance_14 === VOID)
    new ($serializer_14())();
  return $serializer_instance_14;
}
var AnonymousAnswersClass;
function AnonymousAnswers() {
  if (AnonymousAnswersClass === VOID) {
    class $ {
      constructor(takerId, answers) {
        Companion_getInstance_20();
        this.takerId_1 = takerId;
        this.answers_1 = answers;
      }
      toString() {
        return 'AnonymousAnswers(takerId=' + this.takerId_1.toString() + ', answers=' + toString(this.answers_1) + ')';
      }
      hashCode() {
        var result = this.takerId_1.hashCode();
        result = imul(result, 31) + hashCode(this.answers_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AnonymousAnswers()))
          return false;
        if (!this.takerId_1.equals(other.takerId_1))
          return false;
        if (!equals(this.answers_1, other.answers_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_AnonymousAnswers_g848qt_k$(seen0, takerId, answers, serializationConstructorMarker) {
        Companion_getInstance_20();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_17().descriptor_1);
        }
        var $this = createThis(this);
        $this.takerId_1 = takerId;
        $this.answers_1 = answers;
        return $this;
      }
    }
    initMetadataForClass($, 'AnonymousAnswers', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
    AnonymousAnswersClass = $;
  }
  return AnonymousAnswersClass;
}
function AnonymousStart$Companion$$childSerializers$_anonymous__ljfgej() {
  return Companion_getInstance_2().serializer_9w0wvi_k$();
}
function AnonymousStart$Companion$$childSerializers$_anonymous__ljfgej_0() {
  return Companion_getInstance_1().serializer_9w0wvi_k$();
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      constructor() {
        Companion_instance_18 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, AnonymousStart$Companion$$childSerializers$_anonymous__ljfgej);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, tmp_1, lazy(tmp_2, AnonymousStart$Companion$$childSerializers$_anonymous__ljfgej_0)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_18();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_18;
function Companion_getInstance_21() {
  if (Companion_instance_18 === VOID)
    new (Companion_17())();
  return Companion_instance_18;
}
var $serializerClass_15;
function $serializer_15() {
  if ($serializerClass_15 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_15 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.AnonymousStart', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('takerId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('leadershipLevel', false);
        tmp0_serialDesc.addElement_5pzumi_k$('income', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_o3jwja_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_21().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, UuidSerializer_getInstance(), value.takerId_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.leadershipLevel_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.income_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_o3jwja_k$(encoder, value instanceof AnonymousStart() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp8_cached = Companion_getInstance_21().$childSerializers_1;
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp8_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp8_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AnonymousStart().new_org_thecommunitygroupinc_cares_AnonymousStart_352bvm_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_21().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), get_nullable(tmp0_cached[2].get_value_j01efc_k$())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_15 = $;
  }
  return $serializerClass_15;
}
var $serializer_instance_15;
function $serializer_getInstance_18() {
  if ($serializer_instance_15 === VOID)
    new ($serializer_15())();
  return $serializer_instance_15;
}
var AnonymousStartClass;
function AnonymousStart() {
  if (AnonymousStartClass === VOID) {
    class $ {
      constructor(takerId, leadershipLevel, income) {
        Companion_getInstance_21();
        this.takerId_1 = takerId;
        this.leadershipLevel_1 = leadershipLevel;
        this.income_1 = income;
      }
      toString() {
        return 'AnonymousStart(takerId=' + this.takerId_1.toString() + ', leadershipLevel=' + this.leadershipLevel_1.toString() + ', income=' + toString_0(this.income_1) + ')';
      }
      hashCode() {
        var result = this.takerId_1.hashCode();
        result = imul(result, 31) + this.leadershipLevel_1.hashCode() | 0;
        result = imul(result, 31) + (this.income_1 == null ? 0 : this.income_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AnonymousStart()))
          return false;
        if (!this.takerId_1.equals(other.takerId_1))
          return false;
        if (!this.leadershipLevel_1.equals(other.leadershipLevel_1))
          return false;
        if (!equals(this.income_1, other.income_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_AnonymousStart_352bvm_k$(seen0, takerId, leadershipLevel, income, serializationConstructorMarker) {
        Companion_getInstance_21();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_18().descriptor_1);
        }
        var $this = createThis(this);
        $this.takerId_1 = takerId;
        $this.leadershipLevel_1 = leadershipLevel;
        $this.income_1 = income;
        return $this;
      }
    }
    initMetadataForClass($, 'AnonymousStart', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
    AnonymousStartClass = $;
  }
  return AnonymousStartClass;
}
function AnonymousTaking$Companion$$childSerializers$_anonymous__cwll3t() {
  return new (ArrayListSerializer())($serializer_getInstance_13());
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      constructor() {
        Companion_instance_19 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, AnonymousTaking$Companion$$childSerializers$_anonymous__cwll3t)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_19();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_19;
function Companion_getInstance_22() {
  if (Companion_instance_19 === VOID)
    new (Companion_18())();
  return Companion_instance_19;
}
var $serializerClass_16;
function $serializer_16() {
  if ($serializerClass_16 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_16 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.AnonymousTaking', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('progress', false);
        tmp0_serialDesc.addElement_5pzumi_k$('answers', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_2ekgru_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_22().$childSerializers_1;
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, $serializer_getInstance_15(), value.progress_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.answers_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_2ekgru_k$(encoder, value instanceof AnonymousTaking() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp7_cached = Companion_getInstance_22().$childSerializers_1;
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_15(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_15(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return AnonymousTaking().new_org_thecommunitygroupinc_cares_AnonymousTaking_lxwz0t_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_22().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_15()), tmp0_cached[1].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_16 = $;
  }
  return $serializerClass_16;
}
var $serializer_instance_16;
function $serializer_getInstance_19() {
  if ($serializer_instance_16 === VOID)
    new ($serializer_16())();
  return $serializer_instance_16;
}
var AnonymousTakingClass;
function AnonymousTaking() {
  if (AnonymousTakingClass === VOID) {
    class $ {
      constructor(progress, answers) {
        Companion_getInstance_22();
        this.progress_1 = progress;
        this.answers_1 = answers;
      }
      toString() {
        return 'AnonymousTaking(progress=' + toString_0(this.progress_1) + ', answers=' + toString(this.answers_1) + ')';
      }
      hashCode() {
        var result = this.progress_1 == null ? 0 : this.progress_1.hashCode();
        result = imul(result, 31) + hashCode(this.answers_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AnonymousTaking()))
          return false;
        if (!equals(this.progress_1, other.progress_1))
          return false;
        if (!equals(this.answers_1, other.answers_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_AnonymousTaking_lxwz0t_k$(seen0, progress, answers, serializationConstructorMarker) {
        Companion_getInstance_22();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_19().descriptor_1);
        }
        var $this = createThis(this);
        $this.progress_1 = progress;
        $this.answers_1 = answers;
        return $this;
      }
    }
    initMetadataForClass($, 'AnonymousTaking', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
    AnonymousTakingClass = $;
  }
  return AnonymousTakingClass;
}
function nextTakingDate(_this__u8e3s4, completedAt) {
  var tmp0_safe_receiver = _this__u8e3s4.maximumFrequency_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = plus(toLocalDateTime(completedAt, get_TCG_TIME_ZONE()).date_1, tmp0_safe_receiver);
  }
  return tmp;
}
function isComplete(_this__u8e3s4, answers) {
  var tmp0 = shownQuestions(_this__u8e3s4, answers);
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.isEmpty_y1axqb_k$();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp_0;
      if (element.optional_1) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var key = new (ID_1())(element._id_1);
        tmp_0 = (isInterface(answers, KtMap()) ? answers : THROW_CCE()).containsKey_aw81wo_k$(key);
      }
      if (!tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function shownQuestions(_this__u8e3s4, answers) {
  var shown = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = _this__u8e3s4.questions_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var condition = element.showCondition_1;
    var tmp;
    if (condition == null) {
      tmp = true;
    } else {
      // Inline function 'kotlin.takeIf' call
      var this_0 = answers.get_wei43m_k$(new (ID_1())(condition.otherQuestion_1));
      var tmp_0;
      if (shown.contains_aljjnj_k$(new (ID_1())(condition.otherQuestion_1))) {
        tmp_0 = this_0;
      } else {
        tmp_0 = null;
      }
      var answer = tmp_0;
      var tmp_1 = setOfNotNull(answer == null ? null : answer.answerSingleChoice_1);
      var tmp2_elvis_lhs = answer == null ? null : answer.answerMultipleChoice_1;
      var tmp_2;
      if (tmp2_elvis_lhs == null) {
        // Inline function 'kotlin.collections.setOf' call
        tmp_2 = emptySet();
      } else {
        tmp_2 = tmp2_elvis_lhs;
      }
      var chosen = plus_0(tmp_1, tmp_2);
      var tmp$ret$6;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_3;
        if (isInterface(chosen, Collection())) {
          tmp_3 = chosen.isEmpty_y1axqb_k$();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$6 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = chosen.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          if (condition.answerIsOneOf_1.contains_aljjnj_k$(element_0)) {
            tmp$ret$6 = true;
            break $l$block_0;
          }
        }
        tmp$ret$6 = false;
      }
      tmp = tmp$ret$6;
    }
    var isShown = tmp;
    if (isShown) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_1 = new (ID_1())(element._id_1);
      shown.add_utx5q5_k$(element_1);
    }
    if (isShown) {
      destination.add_utx5q5_k$(element);
    }
  }
  return destination;
}
//region block: init
Companion_instance_1 = new (Companion_0())();
Companion_instance_3 = new (Companion_2())();
Companion_instance_6 = new (Companion_5())();
Companion_instance_7 = new (Companion_6())();
Companion_instance_8 = new (Companion_7())();
Companion_instance_12 = new (Companion_11())();
Companion_instance_14 = new (Companion_13())();
Companion_instance_16 = new (Companion_15())();
//endregion
//region block: exports
export {
  _ID___init__impl__k1lb7e_0 as _ID___init__impl__k1lb7e161ss4vhqho8h,
  ID__hashCode_impl_f4lulz_1 as ID__hashCode_impl_f4lulz2dcc8zh8xyyob,
  ID__toString_impl_y5caka_0 as ID__toString_impl_y5caka3idz1jn8rtovq,
  _ID___init__impl__k1lb7e as _ID___init__impl__k1lb7e2eizzchxtswdr,
  ID__toString_impl_y5caka as ID__toString_impl_y5caka2oex5pjttokev,
  Audience_AnonymousEmployee_getInstance as Audience_AnonymousEmployee_getInstance2bv7u5yl59uph,
  Audience_Employers_getInstance as Audience_Employers_getInstance2dlazlq0yh8zq,
  Audience_Families_getInstance as Audience_Families_getInstance8s10akugcgmf,
  Companion_getInstance_20 as Companion_getInstance3b4ushpbkvgrv,
  Companion_getInstance_21 as Companion_getInstance3d75st4ngxjes,
  Companion_instance_16 as Companion_instance3h9d5wsjmuw70,
  Companion_getInstance_22 as Companion_getInstance39bhohmo3c08b,
  Companion_getInstance_13 as Companion_getInstancek2mwqkcqpws,
  Companion_getInstance_12 as Companion_getInstance305gia6954odo,
  FreeText_getInstance as FreeText_getInstance23qqf2uelwn34,
  Companion_getInstance_16 as Companion_getInstance29sht6afyr9n6,
  Companion_getInstance_14 as Companion_getInstance1tychjrdxpayy,
  Companion_instance_12 as Companion_instancebdn3v0qctmd1,
  Companion_getInstance_5 as Companion_getInstance67t3dbcjzlfh,
  Companion_instance_1 as Companion_instance2hpuio2jmf9d2,
  Companion_getInstance_18 as Companion_getInstancecv02zznkeg7m,
  Companion_instance_14 as Companion_instance36og04a4bn8yo,
  AnonymousAnswers as AnonymousAnswers32nmi1m84y0s5,
  AnonymousStart as AnonymousStart3b856zy9p4ann,
  ID_1 as ID2laazuggebybv,
  ShowCondition as ShowCondition2dds7obgg0q2o,
  FreeNumber as FreeNumber2skpobtqdwens,
  MultipleChoice as MultipleChoice1goezt0bzeu0r,
  Scale as Scale39z6qxcb8qv,
  SingleChoice as SingleChoice36vk2iz8s7aee,
  QuestionResponse as QuestionResponse2c5i2ax2qx74j,
  Question as Questionfghiyjhvplgs,
  get_entries as get_entries3lu97yqkn0182,
  ID_0 as ID3b6wrkk3fpdmq,
  SurveyProgress as SurveyProgress2a3z8tdqg3ffh,
  Survey as Survey1bcnex3xrekf,
  isComplete as isComplete1mj6g5clu144t,
  nextTakingDate as nextTakingDate2z4ej6zmlzj64,
  shownQuestions as shownQuestions70e1uhrkjiq4,
};
//endregion

//# sourceMappingURL=survey.mjs.map
